import React from 'react';
import { string, bool } from 'prop-types';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import { ActivityBookmarkPreviewWrapper, Title, Description, ProviderLink, MainContent, FavIcon, Url } from './ActivityBookmarkPreview.styles';
import { Hyperlink } from '../../Atoms/Hyperlink';
import { ActivityBookmarkLoading } from '../../Molecules/ActivityBookmarkLoading';
export const ActivityBookmarkPreview = _ref => {
  let {
    title,
    description,
    favIcon,
    url,
    imgSrc,
    isLoading
  } = _ref;
  // eslint-disable-next-line no-param-reassign
  if (url && !url.includes('://')) url = "https://".concat(url);
  return /*#__PURE__*/React.createElement(React.Fragment, null, isLoading ? /*#__PURE__*/React.createElement(ActivityBookmarkLoading, {
    url: url
  }) : /*#__PURE__*/React.createElement(ActivityBookmarkPreviewWrapper, null, /*#__PURE__*/React.createElement(Hyperlink, {
    href: url,
    target: "_blank",
    rel: "nofollow"
  }, /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(MainContent, null, /*#__PURE__*/React.createElement(CardContent, null, /*#__PURE__*/React.createElement(Title, null, title), description && /*#__PURE__*/React.createElement(Description, {
    "data-test-id": "description"
  }, description)), /*#__PURE__*/React.createElement(ProviderLink, null, favIcon && /*#__PURE__*/React.createElement(FavIcon, {
    "data-test-id": "fav-icon"
  }, /*#__PURE__*/React.createElement("img", {
    src: favIcon,
    alt: "fav icon"
  })), /*#__PURE__*/React.createElement(Url, null, url))), imgSrc && /*#__PURE__*/React.createElement(CardMedia, {
    image: imgSrc,
    "data-test-id": "card-media"
  })))));
};
ActivityBookmarkPreview.propTypes = {
  title: string.isRequired,
  description: string,
  imgSrc: string,
  favIcon: string,
  url: string.isRequired,
  isLoading: bool.isRequired
};
ActivityBookmarkPreview.defaultProps = {
  description: '',
  imgSrc: '',
  favIcon: ''
};